import Module from "./Module";

export default Module;
